import DetailVM from './detail-vm';
export default {
  init : function() {
    console.log('Kadenze.CourseSurveyDetail initialization function called');
    var survey_data = JSON.parse($('#survey_json').val());
    ko.applyBindings(new DetailVM(survey_data), document.getElementById('survey_detail'));
  }
};

